import React, { useEffect, useRef, useState } from 'react';

interface VideoPreviewProps {
  file: File;
  onRemove?: () => void;
}

/**
 * Anteprima del video selezionato prima dell'upload.
 * Mostra il player nativo HTML5 e le informazioni sul file.
 */
const VideoPreview: React.FC<VideoPreviewProps> = ({ file, onRemove }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    // Crea un object URL per il file e lo ripulisce all'unmount
    const url = URL.createObjectURL(file);
    setObjectUrl(url);
    return () => {
      URL.revokeObjectURL(url);
    };
  }, [file]);

  const formatSize = (bytes: number): string => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
  };

  return (
    <div
      style={{
        border: '1px solid #e2e8f0',
        borderRadius: '12px',
        overflow: 'hidden',
        backgroundColor: '#ffffff',
        maxWidth: '600px',
        margin: '0 auto',
      }}
    >
      <div style={{ backgroundColor: '#0f172a', padding: '0.75rem 1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ color: 'white', fontWeight: 600, fontSize: '0.9rem' }}>Anteprima</span>
        {onRemove && (
          <button
            onClick={onRemove}
            style={{
              background: 'none',
              border: 'none',
              color: '#94a3b8',
              cursor: 'pointer',
              fontSize: '1.2rem',
              lineHeight: 1,
              padding: 0,
            }}
            title="Rimuovi file"
          >
            ×
          </button>
        )}
      </div>
      <div style={{ padding: '1rem' }}>
        {objectUrl && (
          <video
            ref={videoRef}
            src={objectUrl}
            controls
            preload="metadata"
            style={{ width: '100%', maxHeight: '300px', backgroundColor: '#000', borderRadius: '8px' }}
          />
        )}
        <div style={{ marginTop: '0.75rem', display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem', color: '#475569' }}>
          <span>{file.name}</span>
          <span>{formatSize(file.size)}</span>
        </div>
      </div>
    </div>
  );
};

export default VideoPreview;